import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const ventajas = [
  {
    icon: 'ri-price-tag-3-line',
    title: 'Presupuesto gratis',
    desc: 'Venimos a tu casa o negocio, evaluamos el trabajo y te damos un precio cerrado sin compromiso. Sin sorpresas.',
    to: '/presupuesto',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Respuesta 24/48h',
    desc: 'Sabemos que un toldo roto en pleno verano urge. Por eso respondemos rápido, especialmente en temporada alta.',
    to: '/reparacion-toldos-malaga',
  },
  {
    icon: 'ri-award-line',
    title: 'Garantía de 2 años',
    desc: 'Todas nuestras reparaciones e instalaciones incluyen garantía por escrito. Trabajo bien hecho, sin letra pequeña.',
    to: '/contacto',
  },
  {
    icon: 'ri-home-6-line',
    title: 'Particulares y negocios',
    desc: 'Atendemos viviendas, comunidades de vecinos, bares, restaurantes y hoteles. Cada cliente recibe un trato personalizado.',
    to: '/toldos-hosteleria',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Todas las marcas',
    desc: 'Reparamos e instalamos toldos de cualquier fabricante. No nos casamos con una marca: buscamos la mejor solución para ti.',
    to: '/instalacion-toldos-malaga',
  },
  {
    icon: 'ri-sun-line',
    title: 'Clima de Málaga',
    desc: 'El sol, el viento de levante y el salitre castigan los toldos. Usamos materiales y técnicas pensados para nuestra costa.',
    to: '/mantenimiento-toldos-malaga',
  },
];

export default function Ventajas() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className={`w-full bg-background-50 py-16 md:py-20 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <span className="inline-flex px-3 py-1.5 rounded-full bg-primary-100/60 text-primary-700 text-xs font-semibold font-label tracking-wide mb-4">
              Por qué elegirnos
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              La diferencia de un<br />servicio local de confianza
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-sm leading-relaxed">
            Más de 15 años reparando e instalando toldos en toda la provincia de Málaga. Costa del Sol, interior y capital.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ventajas.map((item) => (
            <Link
              key={item.title}
              to={item.to}
              className="group flex flex-col gap-4 p-6 md:p-7 bg-background-100/80 rounded-2xl border border-background-200/60 hover:border-primary-200 hover:bg-background-100 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-primary-500 group-hover:text-white text-xl transition-colors duration-300`}></i>
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="text-base font-heading font-bold text-foreground-900">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}